// Navbar.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import MobileNav from "./MobileNav";
import MenuItem from "./MenuItem";
import {
  Flex,
  Image,
  List,
  ListItem,
  Button,
  useTheme,
} from "@chakra-ui/react";
import { FaSignOutAlt } from "react-icons/fa";
import { AuthContext } from "../contexts/AuthContext";
import { processMenuData } from "../utils/menuConfig";

function Navbar() {
  const navigate = useNavigate();
  const { menuData } = useContext(AuthContext);

  const handleLogout = () => {
    // Logout logic
    navigate("/");
  };

  // Logo setup with fallback
  const theme = useTheme();
  const logoSrc = theme?.logo?.nav?.src || '/assets/logo-horizontal.svg';
  const logoAlt = theme?.logo?.nav?.alt || 'Logo';
  const logoSize = theme?.logo?.nav?.boxSize || '150px';
  const clientLogoSrc = theme?.logo?.client?.src;
  const clientLogoAlt = theme?.logo?.client?.alt || 'Client Logo';

  // Process menu data to remove duplicates and sort
  const processedMenuData = processMenuData(menuData);

  return (
    <Flex
      as="nav"
      justify="space-between"
      align="center"
      p="20px 25px"
      bg="primary"
      color="white"
      height="100px"
      position="relative"
      zIndex="2"
    >
      <Flex>
        {/* Main Logo */}
        <Image
          src={logoSrc}
          alt={logoAlt}
          boxSize={logoSize}
          objectFit="contain"
        />
        {/* Client Logo - only render if src exists and is not null */}
        {clientLogoSrc && clientLogoSrc !== null && (
          <Image
            src={clientLogoSrc}
            alt={clientLogoAlt}
            boxSize={logoSize}
            objectFit="contain"
            mx="12"
          />
        )}
      </Flex>
      {/* Desktop Nav */}
      <List display={{ base: "none", lg: "flex" }} alignItems="center">
        {/* Dynamic Menu Items */}
        {processedMenuData.length > 0 ? (
          processedMenuData.map((menuItem, index) => (
            <MenuItem
              key={`${menuItem.menuCode}-${index}`}
              menuItem={menuItem}
            />
          ))
        ) : (
          <ListItem m="0 0.3em">
            <Button variant="noBorder-bgOpaque" disabled>
              Loading Menu...
            </Button>
          </ListItem>
        )}
        {/* Sign-Out Button */}
        <ListItem m="0 0.3em">
          <Button
            variant="pill-bgOpaque"
            leftIcon={<FaSignOutAlt color="white" />}
            onClick={handleLogout}
            p="1.4em"
          >
            Logout
          </Button>
        </ListItem>
      </List>
      {/* Mobile Nav */}
      <MobileNav />
    </Flex>
  );
}

export default Navbar;
